import { useEffect, useRef } from 'react';
import type { JSX } from 'react';

import type { LoadingBarRef } from 'react-top-loading-bar';
import LoadingBar from 'react-top-loading-bar';

type Callbacks = { start: () => void; complete: () => void };
export type LoadingContext = {
	start: () => void;
	complete: () => void;
	listen: (callbacks: Callbacks) => () => void;
};

export function createLoadingContext(): LoadingContext {
	let callbacks: Callbacks[] = [];
	return {
		start: () => {
			callbacks.forEach(({ start }) => start());
		},
		complete: () => {
			callbacks.forEach(({ complete }) => complete());
		},
		listen: (cbs: Callbacks) => {
			callbacks = [...callbacks, cbs];
			return () => {
				callbacks = callbacks.filter((stateCbs) => stateCbs !== cbs);
			};
		},
	};
}

const sunriseLoadingGradient = 'linear-gradient(90deg, #0038BC 34.13%, #4771FF 75.48%, #4AAEFF 92.79%)'; // TODO: get sunrise.gradient.fill.progress token from theme

export function TopLoadingBar({ loadingContext }: { loadingContext?: LoadingContext }): JSX.Element {
	const ref = useRef<LoadingBarRef | null>(null);

	useEffect(() => {
		if (!loadingContext) {
			return undefined;
		}
		const removeListener = loadingContext.listen({
			start: () => ref.current?.continuousStart(0, 1000),
			complete: () => ref.current?.complete(),
		});
		return () => {
			removeListener();
		};
	}, [loadingContext]);

	return <LoadingBar color={sunriseLoadingGradient} ref={ref} />;
}
